import React, { useMemo } from 'react';
import { isSkillup } from '../../../lib/config/project/project';

interface Props {
  totalNumberOfResults: number;
}
const ShowingXResults: React.FC<Props> = ({ totalNumberOfResults }) => {
  const defaultClasses = 'mt-2 tracking-normal font-base';
  const className = useMemo(
    () =>
      isSkillup
        ? `${defaultClasses} text-base font-bold md:text-lg text-left`
        : `text-right lg:text-base text-sm font-light`,
    [],
  );
  return <p data-testid="total_number_of_results" className={className}>Showing {totalNumberOfResults} results.</p>;
};

export default ShowingXResults;
